// Navbar.js
import React from "react";
import { useLocation, Link } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();

  //nav items for every page
  const navItems = {
    "/": ["WORK", "ABOUT", "CONTACT"],
    "/about": ["HOME", "WORK", "CONTACT"],
    "/contact": ["HOME", "WORK", "ABOUT"],
    // work & works
    "/work": ["HOME", "ABOUT", "CONTACT"],
    "/work/GreenPlatter": ["HOME", "WORK", "ABOUT", "CONTACT"],
    "/work/GreenPlatterApp": ["HOME", "WORK", "ABOUT", "CONTACT"],
    "/work/HealthandWellnessTracker": ["HOME", "WORK", "ABOUT", "CONTACT"],
  };

  const currentNavItems = navItems[location.pathname] || [];
  const isWorkPage = location.pathname.startsWith("/work");
  const isContactPage = location.pathname.startsWith("/contact");

  const bgColors = {
    "/": "bg-lightBeige",
    "/about": "bg-lightBeige",
    "/contact": "bg-midBrown",
    // work & works
    "/work": "bg-deep",
    "/work/GreenPlatter": "bg-deep",
    "/work/GreenPlatterApp": "bg-deep",
    "/work/HealthandWellnessTracker": "bg-deep",
  };
  const currentBgColor = bgColors[location.pathname] || "";

  return (
    <>
      <div
        className={`fixed top-0 left-0 w-full h-10 z-40 ${currentBgColor}`}
      ></div>
      <nav
        className={`${
          location.pathname === "/"
            ? "fixed  md:flex flex-col space-y-4 hidden md:ml-[4rem] md:fixed md:top-1/2 md:transform md:-translate-y-1/2 md:w-3/5 md:right-0"
            : "fixed flex space-x-2 z-50 right-3 md:space-x-4 md:right-4 top-2 "
        }`}
      >
        {currentNavItems.map((item) => (
          <Link
            key={item}
            to={`/${item.toLowerCase() === "home" ? "" : item.toLowerCase()}`}
            className={`active:text-pink ${
              location.pathname === "/"
                ? "text-6xl font-black hover:text-lightBrown leading-none md:text-8xl lg:text-Rem9 xl:text-Rem10  2xl:text-Rem11  "
                : `text-lg font-extrabold text-center min-w-[70px] ${
                    isWorkPage
                      ? "text-beige hover:text-pink"
                      : "hover:text-lightBrown "
                  }${
                    isContactPage
                      ? "text-lightBrown hover:text-pink"
                      : "hover:text-lightBrown "
                  }`
            }`}
          >
            {item}
          </Link>
        ))}
      </nav>
    </>
  );
};

export default Navbar;
